export default __webpack_public_path__ + "/assets/vivi-partner-01-lg.jpg";